<div>
	<div class="filter-column">
		<select [(ngModel)]="selectedColumn" (change)="onSelectColumn()" [ngClass]="{'select-greyout': selectedColumn===null}">
			<option [ngValue]="null" class="select-option-placeholder">
				&lt; Select A Field &gt;
			</option>
			<option *ngFor="let column of columns" [ngValue]="column">{{column[displayField]}}</option>
		</select>
	</div>
	<div class="operator">
		<select [(ngModel)]="selectedOperator" (change)="onSelectOperator()" [ngClass]="{'select-greyout': selectedColumn===null}">
			<option [ngValue]="null"></option>
			<option *ngFor="let operator of availableOperators" [ngValue]="operator">{{operator.symbol}}</option>
		</select>
	</div>
	<div class="filter-value">
		<input *ngIf="!valueList" type="text" name="filterValue" [(ngModel)]="filterValue" (input)="updateFilter()" [disabled]="selectedOperator&&noFilterValueOperatorNames.indexOf(selectedOperator.name)>-1" (keyup.enter)="onEnter()">
		<select *ngIf="valueList" [(ngModel)]="filterValue" (change)="updateFilter()" (keyup.enter)="onEnter()">
			<option *ngFor="let value of valueList">{{value}}</option>
		</select>
	</div>
	<div *ngIf="isAutoCheckDomain && domainList.length" class="column-domain" title="Select up to 5 values from the list">
		<i class="glyphicons glyphicons-more" (click)="toggleDomain()"></i>
		<div *ngIf="showDomain" class="domain-list">
			<div *ngFor="let dom of domainList; let idx = index;">
				<input type="checkbox" name="" [(ngModel)]="dom.selected" (ngModelChange)="onSelectDomain()" [disabled]="!dom.selected&&exceedMax">
				<label>{{dom[domainDisplayCol]}}</label>
			</div>
		</div>
	</div>
</div>
